import React, { useMemo } from 'react'
import styles from './MicrositePlanExpiryCountdown.module.css'
import { CalendarClock } from 'lucide-react'

/**
 * MicrositePlanExpiryCountdown
 * Shows days remaining until plan expiry with color warning —
 * used on MicrositePlan and MicrositeDashboard.
 *
 * Usage:
 *   <MicrositePlanExpiryCountdown expiresOn={plan.expiresOn} />
 */
const MicrositePlanExpiryCountdown = ({ expiresOn }) => {
    const days = useMemo(() => {
        if (!expiresOn) return null
        const diff = new Date(expiresOn.replace(' ', 'T')).getTime() - Date.now()
        return Math.ceil(diff / 86400000)
    }, [expiresOn])

    if (days === null) {
        return <span className={styles.neutral}>No expiry set</span>
    }

    if (days < 0) {
        return (
            <span className={styles.danger}>
                <CalendarClock size={13} />
                Expired {Math.abs(days)} day{Math.abs(days) === 1 ? '' : 's'} ago
            </span>
        )
    }

    const tone = days <= 7 ? 'danger' : days <= 30 ? 'warning' : 'good'

    return (
        <span className={styles[tone]}>
            <CalendarClock size={13} />
            Renews in {days} day{days === 1 ? '' : 's'}
        </span>
    )
}

export default MicrositePlanExpiryCountdown